import { Navigate, Outlet } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore, restoreRememberedUser } from "../../stores/authStore";

export function AuthGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const getToken = useAuthStore((s) => s.getToken);
  const [isChecking, setIsChecking] = useState(true);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    // Validate token on component mount
    const validateAuth = () => {
      let hasAuth = false;
      const token = getToken();
      const authState = useAuthStore.getState();

      if (token && authState.user) {
        hasAuth = true;
      } else {
        // Try to restore from "remember me" localStorage
        const rememberedUser = restoreRememberedUser();
        if (rememberedUser) {
          useAuthStore.getState().login(rememberedUser, true);
          hasAuth = true;
        }
      }

      setIsValid(hasAuth);
      setIsChecking(false);
    };

    // Small delay to ensure stores are initialized
    const timer = setTimeout(validateAuth, 0);
    return () => clearTimeout(timer);
  }, [getToken]);

  useEffect(() => {
    // Listen for logout event (triggered by API 401 error)
    const handleLogout = () => {
      console.log("[AuthGuard] Logout event received, logging out user");
      useAuthStore.getState().logout();
      setIsValid(false);
    };

    window.addEventListener("user-logout", handleLogout);
    return () => window.removeEventListener("user-logout", handleLogout);
  }, []);

  // Show nothing while checking auth status
  if (isChecking) {
    return null;
  }

  if (!isAuthenticated || !isValid) {
    console.log("[AuthGuard] User not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
